module.exports = __webpack_public_path__ + "static/img/icon3.7e100972.png";